let systemConfig = window.systemConfig
export default {
  // 企信
  // {{$t('chat.memo')}}
  // $t('chat.memo')
  // this.$t('chat.memo')
  chat: {
    qixin: systemConfig && systemConfig.qixin ? systemConfig.qixin.zh_TW : '企信',
    open: '展開',
    communicate: '點擊可以與同事實時溝通',
    Initiatechat: '發起聊天',
    groupchat: '選擇群聊',
    chat: '聊天',
    seemore: '查看更多消息',
    unread: '未讀',
    already: '已讀',
    peoplehaveread: '人已讀',
    allread: '全部已讀',
    withdraw: '撤回',
    Noannouncement: '暫無群公告',
    Groupmembers: '群成員',
    Addmember: '添加成員',
    manage: '管理員',
    Groupchatstaff: '群聊全員',
    Groupannouncement: '群公告',
    transfer: '轉讓群聊',
    topchat: '置頂聊天',
    toptalk: '置頂會話',
    dissolve: '解散群聊',
    quit: '退出群聊',
    expression: '表情',
    newmessage: '條新消息',
    entersend: '按Enter發送消息',
    send: '發送',
    view: '查看群聊',
    quitTip: '退出後，妳將不再接受該群組中的消息，請謹慎操作。你確定要退出群聊嗎？',
    dissolveTip: '提示：解散後，該群聊不可恢復，群聊中的成員將收到解散消息，請謹慎操作。',
    dissolve2: '你確定要解散群聊嗎？',
    selectmember: '選擇成員',
    readnotread: '已讀未讀',
    messagedetails: '消息詳情',
    read: '已讀',
    notread: '未讀',
    groupmemberlist: '@群成員列表',
    draft: '草稿',
    everyone: '所有人',
    message_empty: '不能發送空白消息！',
    person: '人',
    recalled1: '對方撤回了壹條消息',
    recalled2: '妳撤回了壹條消息',
    recalled3: '撤回了壹條消息',
    you: '妳',
    message_long: '消息內容超長，請分條發送！',
    selecttransfer: '請選擇轉讓成員！',
    welcome: '歡迎',
    jointhisgroup: '加入本群',
    adminwill: '管理員將',
    removegroup: '移出群聊',

    messagecenter: '消息中心',
    markallread: '全部標記為已讀',
    modulename: '模塊名稱',
    robot: '機器人',
    onlyunread: '只查看未讀消息',
    noauthority: '無權查看或數據已刪除',
    addmemo: '新增備忘錄',
    // 20210305
    residueprocessingtime: '剩余處理時間',
    hasatimeout: '已超時'
  }
}
